import _reduce from 'lodash/reduce';
import {isString} from '@/js/helpers/type-checkers';

export default function getResponseError(error) {
    if (!(error.response && error.response.data && error.response.data.errors)) {
        return {_errors: [error.message]};
    }

    const errors = _reduce(
        error.response.data.errors,
        (errorObject, value, key) => pushError(errorObject, key, value),
        {_errors: []},
    );

    return {errors};
}

const pushError = function (errorObject, key, value) {
    const field = parseField(key);

    errorObject[field] = (errorObject[field] || []).concat(Array.isArray(value) ? value : [value]);

    return errorObject;
};

const parseField = function (key) {
    if (/^\d+/.test(key) || !isString(key)) {
        return '_errors';
    }

    const arrayKeyRegularExpression = /^(.*?)\..*$/;

    if (arrayKeyRegularExpression.test(key)) {
        return key.replace(arrayKeyRegularExpression, '$1');
    }

    return key;
};
